import { Grid, Typography } from "@mui/material";
import { isArray } from "lodash";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { EmptyPanel } from "../../../brand/projects/common/EmptyPanel";
import { IEmbed } from "./interface";
import { EmbedCard } from "./SingleEmbed";
import { Button } from "../../../../components/Button/Button";
import { DotLottleLoader } from "../../../../components/Loader";
import { useUser } from "../../../../hooks/useUser";
import { isBrand, isRMN } from "../../../../utils";

export interface EmbedsContainerProps {
  loading?: boolean;
  error?: null | string;
  embeds: null | IEmbed[];
  onSelectEmbed: (embed: IEmbed) => void;
  onDeleteEmbed?: (i: number) => any;
  refetch?: () => void;
}
export const EmbedsContainer = ({
  embeds,
  loading,
  error,
  onDeleteEmbed,
  onSelectEmbed,
  ...rest
}: EmbedsContainerProps) => {
  const navigate = useNavigate();
  const { user, role } = useUser();
  const [searchParams] = useSearchParams();

  if (loading && (!isArray(embeds) || embeds.length === 0))
    return <DotLottleLoader fill={false} />;

  // fetching videos fail
  if (!isArray(embeds) && error)
    return (
      <Typography variant="h4" textAlign="center">
        Error while fetching videos
      </Typography>
    );

  // fetching's succeed but nothing to display
  if (isArray(embeds) && embeds.length === 0) {
    const isAnyFilterSelected = Array.from(searchParams.keys())
      .filter((e) => !["limit"].includes(e))
      .join("&");

    if (isAnyFilterSelected) {
      return <EmptyPanel text="No items found based on your filters" />;
    }
    return (
      <EmptyPanel
        text="Create an order first to start making stories!"
        button={
          <Button
            onClick={() => navigate("/video-production/orders?create=new")}
          >
            {isBrand(role) || isRMN(user) ? 'Request A Quote' : 'New Order'}
          </Button>
        }
      />
    );
  }

  return (
    <Grid container spacing={2} columns={{ xs: 1, sm: 2, md: 3, lg: 4, xl: 5 }}>
      {Array.isArray(embeds) &&
        embeds.map((embed: IEmbed, i) => (
          <Grid item xs={1} key={i}>
            <EmbedCard
              {...rest}
              embed={embed}
              onClick={() => onSelectEmbed(embed)}
              onDelete={() => onDeleteEmbed?.(i)}
            />
          </Grid>
        ))}
    </Grid>
  );
};
